import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "company-sso-configuration" };
const _hoisted_2 = { class: "col-12 mb-3" };
const _hoisted_3 = { class: "form-check form-switch" };
const _hoisted_4 = { class: "sso-fields" };
const _hoisted_5 = { class: "d-flex flex-wrap" };
const _hoisted_6 = { class: "col-md-6 mb-3" };
const _hoisted_7 = { class: "form-label required" };
const _hoisted_8 = {
    class: "fa fa-question-circle text-muted",
    title: "The URL of your identity provider (e.g., https://login.microsoftonline.com/{tenant-id}/v2.0)"
};
const _hoisted_9 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_10 = { class: "col-md-6 mb-3" };
const _hoisted_11 = { class: "form-label required" };
const _hoisted_12 = {
    class: "fa fa-question-circle text-muted",
    title: "Unique subdomain for this company (e.g., 'acme' for acme.yourdomain.com)"
};
const _hoisted_13 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_14 = { class: "text-muted" };
const _hoisted_15 = { class: "d-flex flex-wrap" };
const _hoisted_16 = { class: "col-md-6 mb-3" };
const _hoisted_17 = { class: "form-label required" };
const _hoisted_18 = {
    class: "fa fa-question-circle text-muted",
    title: "Application/Client ID from your SSO provider"
};
const _hoisted_19 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_20 = { class: "col-md-6 mb-3" };
const _hoisted_21 = {
    class: "fa fa-question-circle text-muted",
    title: "Client secret from your SSO provider (stored encrypted)"
};
const _hoisted_22 = {
    key: 0,
    class: "invalid-feedback"
};
const _hoisted_23 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_24 = { class: "d-flex flex-wrap" };
const _hoisted_25 = { class: "col-md-6 mb-3" };
const _hoisted_26 = { class: "form-label" };
const _hoisted_27 = {
    class: "fa fa-question-circle text-muted",
    title: "Comma-separated list of OAuth scopes to request"
};
const _hoisted_28 = { class: "d-flex flex-wrap" };
const _hoisted_29 = { class: "col-md-3 mb-3" };
const _hoisted_30 = { class: "col-md-3 mb-3" };
const _hoisted_31 = { class: "col-md-3 mb-3" };
const _hoisted_32 = { class: "col-md-3 mb-3" };
const _hoisted_33 = { class: "d-flex flex-wrap" };
const _hoisted_34 = { class: "col-md-6 mb-3" };
const _hoisted_35 = { class: "d-flex flex-wrap" };
const _hoisted_36 = {
    key: 0,
    class: "col-md-4 mb-3"
};
const _hoisted_37 = { class: "form-label" };
const _hoisted_38 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Administrator (e.g., 'admin.1', 'Admins')"
};
const _hoisted_39 = {
    key: 1,
    class: "col-md-4 mb-3"
};
const _hoisted_40 = { class: "form-label" };
const _hoisted_41 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Power User (e.g., 'PowerUser', 'Power Users')"
};
const _hoisted_42 = { class: "form-label" };
const _hoisted_43 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Client (e.g., 'Client', 'Users')"
};
const _hoisted_44 = { class: "d-flex flex-wrap" };
const _hoisted_45 = { class: "form-label" };
const _hoisted_46 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Client Administrator (e.g., 'ClientAdmin', 'Client Admins')"
};
const _hoisted_47 = { class: "form-label" };
const _hoisted_48 = {
    class: "fa fa-question-circle text-muted",
    title: "SSO role/group name that maps to Client Installer (e.g., 'Installer', 'Installers')"
};
const _hoisted_49 = { class: "col-12 mb-3" };
const _hoisted_50 = { class: "form-check" };
const _hoisted_51 = { class: "mt-3" };
const _hoisted_52 = { class: "col-12" };
const _hoisted_53 = { class: "alert alert-warning" };
const _hoisted_54 = { class: "mt-2 d-block" };
const _hoisted_55 = { class: "mt-2" };
const _hoisted_56 = { class: "col-12" };
const _hoisted_57 = { class: "card" };
const _hoisted_58 = { class: "card-body" };
const _hoisted_59 = { class: "col-md-6 mb-3" };
const _hoisted_60 = { class: "form-label" };
const _hoisted_61 = {
    class: "fa fa-question-circle text-muted",
    title: "Redirect URI path (must match configuration in your SSO provider)"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_button = _resolveComponent("b-button");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[116] || (_cache[116] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "col-12" }, [
                _createElementVNode("div", { class: "alert alert-info" }, [
                    _createElementVNode("i", { class: "fa fa-info-circle me-2" }),
                    _createTextVNode(),
                    _createElementVNode("strong", null, "Single Sign-On (SSO) Configuration"),
                    _createTextVNode(),
                    _createElementVNode("p", { class: "mb-0 mt-2" }, "\r\n\t\t\t\t\t\tConfigure OpenID Connect authentication for this company. Users will authenticate through your identity provider (Azure AD, Okta, Keycloak, etc.).\r\n\t\t\t\t\t")
                ])
            ])
        ], -1 /* CACHED */)),
        _cache[117] || (_cache[117] = _createTextVNode()),
        _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "ssoEnabledSwitch",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.config.ssoEnabled) = $event)),
                        onChange: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.onSsoEnabledChanged && _ctx.onSsoEnabledChanged(...args)))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.config.ssoEnabled]
                    ]),
                    _cache[20] || (_cache[20] = _createTextVNode()),
                    _cache[21] || (_cache[21] = _createElementVNode("label", {
                        class: "form-check-label fw-bold",
                        for: "ssoEnabledSwitch"
                    }, "\r\n\t\t\t\t\t\tEnable SSO Authentication\r\n\t\t\t\t\t", -1 /* CACHED */))
                ]),
                _cache[22] || (_cache[22] = _createTextVNode()),
                _cache[23] || (_cache[23] = _createElementVNode("small", { class: "text-muted ms-4" }, "\r\n\t\t\t\t\tWhen enabled, users from this company will authenticate via your SSO provider\r\n\t\t\t\t", -1 /* CACHED */))
            ])
        ]),
        _cache[118] || (_cache[118] = _createTextVNode()),
        _createCommentVNode(" SSO Configuration Fields (shown only when enabled) "),
        _cache[119] || (_cache[119] = _createTextVNode()),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
            _cache[102] || (_cache[102] = _createElementVNode("div", null, [
                _createElementVNode("div", { class: "col-12" }, [
                    _createElementVNode("h5", { class: "text-muted mb-3" }, [
                        _createElementVNode("i", { class: "fa fa-cog me-2" }),
                        _createTextVNode("Identity Provider Settings\r\n\t\t\t\t\t")
                    ])
                ])
            ], -1 /* CACHED */)),
            _cache[103] || (_cache[103] = _createTextVNode()),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, [
                        _cache[24] || (_cache[24] = _createTextVNode("\r\n\t\t\t\t\t\tAuthority URL\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("i", _hoisted_8, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _cache[25] || (_cache[25] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.authority,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.config.authority) = $event)),
                        modelModifiers: { trim: true },
                        type: "url",
                        placeholder: "https://login.microsoftonline.com/your-tenant-id/v2.0",
                        class: _normalizeClass({ 'is-invalid': _ctx.showValidation && !_ctx.config.authority }),
                        maxlength: "500"
                    }, null, 8 /* PROPS */, ["modelValue", "class"]),
                    _cache[26] || (_cache[26] = _createTextVNode()),
                    (_ctx.showValidation && !_ctx.config.authority)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "\r\n\t\t\t\t\t\tAuthority URL is required when SSO is enabled\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true)
                ]),
                _cache[32] || (_cache[32] = _createTextVNode()),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, [
                        _cache[27] || (_cache[27] = _createTextVNode("\r\n\t\t\t\t\t\tSubdomain\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("i", _hoisted_12, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _cache[29] || (_cache[29] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.subdomain,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.config.subdomain) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "acme",
                        class: _normalizeClass({ 'is-invalid': _ctx.showValidation && !_ctx.config.subdomain }),
                        maxlength: "100",
                        onInput: _ctx.validateSubdomain
                    }, null, 8 /* PROPS */, ["modelValue", "class", "onInput"]),
                    _cache[30] || (_cache[30] = _createTextVNode()),
                    (_ctx.showValidation && !_ctx.config.subdomain)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "\r\n\t\t\t\t\t\tSubdomain is required when SSO is enabled\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true),
                    _cache[31] || (_cache[31] = _createTextVNode()),
                    _createElementVNode("small", _hoisted_14, [
                        _cache[28] || (_cache[28] = _createTextVNode("\r\n\t\t\t\t\t\tURL: ", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.subdomainPreview), 1 /* TEXT */)
                    ])
                ])
            ]),
            _cache[104] || (_cache[104] = _createTextVNode()),
            _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, [
                        _cache[33] || (_cache[33] = _createTextVNode("\r\n\t\t\t\t\t\tClient ID\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("i", _hoisted_18, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _cache[34] || (_cache[34] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.clientId,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.config.clientId) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "your-client-id",
                        class: _normalizeClass({ 'is-invalid': _ctx.showValidation && !_ctx.config.clientId }),
                        maxlength: "200"
                    }, null, 8 /* PROPS */, ["modelValue", "class"]),
                    _cache[35] || (_cache[35] = _createTextVNode()),
                    (_ctx.showValidation && !_ctx.config.clientId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "\r\n\t\t\t\t\t\tClient ID is required when SSO is enabled\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true)
                ]),
                _cache[40] || (_cache[40] = _createTextVNode()),
                _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", {
                        class: _normalizeClass(["form-label", { 'required': _ctx.isNewSsoConfig }])
                    }, [
                        _cache[36] || (_cache[36] = _createTextVNode("\r\n\t\t\t\t\t\tClient Secret\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("i", _hoisted_21, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ], 2 /* CLASS */),
                    _cache[37] || (_cache[37] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.clientSecret,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.config.clientSecret) = $event)),
                        modelModifiers: { trim: true },
                        type: "password",
                        placeholder: _ctx.isNewSsoConfig ? 'Enter client secret' : 'Leave blank to keep existing secret',
                        class: _normalizeClass({ 'is-invalid': _ctx.showValidation && _ctx.isNewSsoConfig && !_ctx.config.clientSecret }),
                        maxlength: "1000"
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "class"]),
                    _cache[38] || (_cache[38] = _createTextVNode()),
                    (_ctx.showValidation && _ctx.isNewSsoConfig && !_ctx.config.clientSecret)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, "\r\n\t\t\t\t\t\tClient Secret is required for new SSO configuration\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true),
                    _cache[39] || (_cache[39] = _createTextVNode()),
                    (!_ctx.isNewSsoConfig)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_23, "\r\n\t\t\t\t\t\tLeave blank to keep the existing secret\r\n\t\t\t\t\t"))
                        : _createCommentVNode("v-if", true)
                ])
            ]),
            _cache[105] || (_cache[105] = _createTextVNode()),
            _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, [
                        _cache[41] || (_cache[41] = _createTextVNode("\r\n\t\t\t\t\t\tOAuth Scopes\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("i", _hoisted_27, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _cache[42] || (_cache[42] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.scopesString,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.scopesString) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "openid, profile, email",
                        maxlength: "500"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _cache[43] || (_cache[43] = _createTextVNode()),
                    _cache[44] || (_cache[44] = _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tDefault: openid, profile, email\r\n\t\t\t\t\t", -1 /* CACHED */))
                ])
            ]),
            _cache[106] || (_cache[106] = _createStaticVNode(" <div class=\"mt-3\"><div class=\"col-12\"><h5 class=\"text-muted mb-3\"><i class=\"fa fa-user-tag me-2\"></i>Claim Mappings\r\n\t\t\t\t\t</h5> <p class=\"text-muted small\">\r\n\t\t\t\t\t\tSpecify which claims from your SSO provider contain user information. Use defaults for standard OIDC providers.\r\n\t\t\t\t\t</p></div></div> ", 3)),
            _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                    _cache[45] || (_cache[45] = _createElementVNode("label", { class: "form-label" }, "Username Claim", -1 /* CACHED */)),
                    _cache[46] || (_cache[46] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.userNameClaimType,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.config.userNameClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "preferred_username",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _cache[53] || (_cache[53] = _createTextVNode()),
                _createElementVNode("div", _hoisted_30, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", { class: "form-label" }, "Email Claim", -1 /* CACHED */)),
                    _cache[48] || (_cache[48] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.emailClaimType,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.config.emailClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "email",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _cache[54] || (_cache[54] = _createTextVNode()),
                _createElementVNode("div", _hoisted_31, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", { class: "form-label" }, "First Name Claim", -1 /* CACHED */)),
                    _cache[50] || (_cache[50] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.firstNameClaimType,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.config.firstNameClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "given_name",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _cache[55] || (_cache[55] = _createTextVNode()),
                _createElementVNode("div", _hoisted_32, [
                    _cache[51] || (_cache[51] = _createElementVNode("label", { class: "form-label" }, "Last Name Claim", -1 /* CACHED */)),
                    _cache[52] || (_cache[52] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.lastNameClaimType,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.config.lastNameClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "family_name",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"])
                ])
            ]),
            _cache[107] || (_cache[107] = _createTextVNode()),
            _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                    _cache[56] || (_cache[56] = _createElementVNode("label", { class: "form-label" }, "Roles Claim Type", -1 /* CACHED */)),
                    _cache[57] || (_cache[57] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.config.rolesClaimType,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.config.rolesClaimType) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "roles",
                        maxlength: "100"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _cache[58] || (_cache[58] = _createTextVNode()),
                    _cache[59] || (_cache[59] = _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tThe claim that contains user roles/groups from SSO provider\r\n\t\t\t\t\t", -1 /* CACHED */))
                ])
            ]),
            _cache[108] || (_cache[108] = _createStaticVNode(" <div class=\"mt-3\"><div class=\"col-12\"><h5 class=\"text-muted mb-3\"><i class=\"fa fa-users me-2\"></i>Role Mappings\r\n\t\t\t\t\t</h5> <p class=\"text-muted small\">\r\n\t\t\t\t\t\tMap SSO roles/groups from your identity provider to application roles. \r\n\t\t\t\t\t\tEnter the exact role or group name as it appears in your SSO provider.\r\n\t\t\t\t\t</p></div></div> ", 3)),
            _createElementVNode("div", _hoisted_35, [
                (!_ctx.isCloudHosting)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("label", _hoisted_37, [
                            _cache[60] || (_cache[60] = _createTextVNode("\r\n\t\t\t\t\t\tAdministrator Role\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("i", _hoisted_38, null, 512 /* NEED_PATCH */), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                ]
                            ])
                        ]),
                        _cache[61] || (_cache[61] = _createTextVNode()),
                        _createVNode(_component_b_form_input, {
                            modelValue: _ctx.administratorRole,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.administratorRole) = $event)),
                            modelModifiers: { trim: true },
                            type: "text",
                            placeholder: "e.g., admin.1",
                            maxlength: "200"
                        }, null, 8 /* PROPS */, ["modelValue"]),
                        _cache[62] || (_cache[62] = _createTextVNode()),
                        _cache[63] || (_cache[63] = _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tFull system administrator access\r\n\t\t\t\t\t", -1 /* CACHED */))
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[72] || (_cache[72] = _createTextVNode()),
                (!_ctx.isCloudHosting)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("label", _hoisted_40, [
                            _cache[64] || (_cache[64] = _createTextVNode("\r\n\t\t\t\t\t\tPower User Role\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                            _withDirectives(_createElementVNode("i", _hoisted_41, null, 512 /* NEED_PATCH */), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                ]
                            ])
                        ]),
                        _cache[65] || (_cache[65] = _createTextVNode()),
                        _createVNode(_component_b_form_input, {
                            modelValue: _ctx.powerUserRole,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.powerUserRole) = $event)),
                            modelModifiers: { trim: true },
                            type: "text",
                            placeholder: "e.g., PowerUser",
                            maxlength: "200"
                        }, null, 8 /* PROPS */, ["modelValue"]),
                        _cache[66] || (_cache[66] = _createTextVNode()),
                        _cache[67] || (_cache[67] = _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tAdvanced user with elevated permissions\r\n\t\t\t\t\t", -1 /* CACHED */))
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[73] || (_cache[73] = _createTextVNode()),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-md-4 mb-3", { 'col-md-6': _ctx.isCloudHosting }])
                }, [
                    _createElementVNode("label", _hoisted_42, [
                        _cache[68] || (_cache[68] = _createTextVNode("\r\n\t\t\t\t\t\tClient Role\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("i", _hoisted_43, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _cache[69] || (_cache[69] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.clientRole,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.clientRole) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "e.g., Client",
                        maxlength: "200"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _cache[70] || (_cache[70] = _createTextVNode()),
                    _cache[71] || (_cache[71] = _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tStandard user access\r\n\t\t\t\t\t", -1 /* CACHED */))
                ], 2 /* CLASS */)
            ]),
            _cache[109] || (_cache[109] = _createTextVNode()),
            _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", {
                    class: _normalizeClass(["col-md-4 mb-3", { 'col-md-6': _ctx.isCloudHosting }])
                }, [
                    _createElementVNode("label", _hoisted_45, [
                        _cache[74] || (_cache[74] = _createTextVNode("\r\n\t\t\t\t\t\tClient Administrator Role\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("i", _hoisted_46, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _cache[75] || (_cache[75] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.clientAdministratorRole,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.clientAdministratorRole) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "e.g., ClientAdmin",
                        maxlength: "200"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _cache[76] || (_cache[76] = _createTextVNode()),
                    _cache[77] || (_cache[77] = _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tClient-level administrator access\r\n\t\t\t\t\t", -1 /* CACHED */))
                ], 2 /* CLASS */),
                _cache[82] || (_cache[82] = _createTextVNode()),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-md-4 mb-3", { 'col-md-6': _ctx.isCloudHosting }])
                }, [
                    _createElementVNode("label", _hoisted_47, [
                        _cache[78] || (_cache[78] = _createTextVNode("\r\n\t\t\t\t\t\tClient Installer Role\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("i", _hoisted_48, null, 512 /* NEED_PATCH */), [
                            [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                            ]
                        ])
                    ]),
                    _cache[79] || (_cache[79] = _createTextVNode()),
                    _createVNode(_component_b_form_input, {
                        modelValue: _ctx.clientInstallerRole,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.clientInstallerRole) = $event)),
                        modelModifiers: { trim: true },
                        type: "text",
                        placeholder: "e.g., Installer",
                        maxlength: "200"
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _cache[80] || (_cache[80] = _createTextVNode()),
                    _cache[81] || (_cache[81] = _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\tInstaller/technician access\r\n\t\t\t\t\t", -1 /* CACHED */))
                ], 2 /* CLASS */)
            ]),
            _cache[110] || (_cache[110] = _createTextVNode()),
            _cache[111] || (_cache[111] = _createElementVNode("div", { class: "mt-3" }, [
                _createElementVNode("div", { class: "col-12" }, [
                    _createElementVNode("h5", { class: "text-muted mb-3" }, [
                        _createElementVNode("i", { class: "fa fa-shield-alt me-2" }),
                        _createTextVNode("User Provisioning\r\n\t\t\t\t\t")
                    ])
                ])
            ], -1 /* CACHED */)),
            _cache[112] || (_cache[112] = _createTextVNode()),
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                        _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "autoAssignSwitch",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.config.autoAssignAllSitesAndSystems) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, _ctx.config.autoAssignAllSitesAndSystems]
                        ]),
                        _cache[83] || (_cache[83] = _createTextVNode()),
                        _cache[84] || (_cache[84] = _createElementVNode("label", {
                            class: "form-check-label",
                            for: "autoAssignSwitch"
                        }, [
                            _createElementVNode("strong", null, "Auto-assign all sites and systems to new SSO users")
                        ], -1 /* CACHED */))
                    ]),
                    _cache[85] || (_cache[85] = _createTextVNode()),
                    _cache[86] || (_cache[86] = _createElementVNode("small", { class: "text-muted ms-4" }, "\r\n\t\t\t\t\t\tWhen enabled, newly created SSO users automatically get access to all sites and systems in this company.\r\n\t\t\t\t\t\tWhen disabled, access must be manually assigned by an administrator.\r\n\t\t\t\t\t", -1 /* CACHED */))
                ])
            ]),
            _cache[113] || (_cache[113] = _createTextVNode()),
            _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                        _cache[87] || (_cache[87] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1 /* CACHED */)),
                        _cache[88] || (_cache[88] = _createTextVNode()),
                        _cache[89] || (_cache[89] = _createElementVNode("strong", null, "Important:", -1 /* CACHED */)),
                        _cache[90] || (_cache[90] = _createTextVNode(" After configuring SSO, you must register the following callback URL in your identity provider:\r\n\t\t\t\t\t\t", -1 /* CACHED */)),
                        _cache[91] || (_cache[91] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _cache[92] || (_cache[92] = _createTextVNode()),
                        _createElementVNode("code", _hoisted_54, _toDisplayString(_ctx.callbackUrlPreview), 1 /* TEXT */),
                        _cache[93] || (_cache[93] = _createTextVNode()),
                        _cache[94] || (_cache[94] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _cache[95] || (_cache[95] = _createTextVNode()),
                        _createVNode(_component_b_button, {
                            size: "sm",
                            variant: "link",
                            class: "p-0 mt-2",
                            onClick: _cache[18] || (_cache[18] = ($event) => (_ctx.showAdvancedSettings = !_ctx.showAdvancedSettings))
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("i", {
                                    class: _normalizeClass(_ctx.showAdvancedSettings ? 'fa fa-chevron-up' : 'fa fa-chevron-down')
                                }, null, 2 /* CLASS */),
                                _createTextVNode(" " + _toDisplayString(_ctx.showAdvancedSettings ? 'Hide' : 'Show') + " Advanced Settings\r\n\t\t\t\t\t\t", 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]),
            _cache[114] || (_cache[114] = _createTextVNode()),
            _createCommentVNode(" Advanced Settings "),
            _cache[115] || (_cache[115] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                            _cache[100] || (_cache[100] = _createElementVNode("h6", { class: "card-title text-muted" }, [
                                _createElementVNode("i", { class: "fa fa-cogs me-2" }),
                                _createTextVNode("Advanced Settings\r\n\t\t\t\t\t\t\t")
                            ], -1 /* CACHED */)),
                            _cache[101] || (_cache[101] = _createTextVNode()),
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("label", _hoisted_60, [
                                        _cache[96] || (_cache[96] = _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tCallback Path\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                        _withDirectives(_createElementVNode("i", _hoisted_61, null, 512 /* NEED_PATCH */), [
                                            [
                                                _directive_b_tooltip,
                                                void 0,
                                                void 0,
                                                { hover: true }
                                            ]
                                        ])
                                    ]),
                                    _cache[97] || (_cache[97] = _createTextVNode()),
                                    _createVNode(_component_b_form_input, {
                                        modelValue: _ctx.config.callbackPath,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.config.callbackPath) = $event)),
                                        modelModifiers: { trim: true },
                                        type: "text",
                                        placeholder: "/signin-oidc",
                                        maxlength: "200"
                                    }, null, 8 /* PROPS */, ["modelValue"]),
                                    _cache[98] || (_cache[98] = _createTextVNode()),
                                    _cache[99] || (_cache[99] = _createElementVNode("small", { class: "text-muted" }, "\r\n\t\t\t\t\t\t\t\t\t\tDefault: /signin-oidc (only change if required by your SSO provider)\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */))
                                ])
                            ])
                        ])
                    ])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.showAdvancedSettings]
            ])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.config.ssoEnabled]
        ])
    ]));
}
